export const EXPLORER_ADDR = "https://arbiscan.io/"
export const SmolPuddleContract = "0xa39eAd9429AB35bFA7aA85786bcddA500a78155D"
